<template>
	<div>
		<TopAppBar
			leftBtnMode="arrow_back"
			:rightBtnMode="rightBtnMode"
			:title= "brandName"
			:leftBtnMethod="confirmOnCancel"
			:rightBtnMethod="rightBtnMethod"
      :hideCategory="false"
			:staticMode="true"
		>
		</TopAppBar>
	<div class="d-flex h-full flex-column">
		<TopAppBarDrawer></TopAppBarDrawer>
		<main class="main-wrapper flex-grow-1">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex justify-content-center align-items-center">
					{{crop ? this.$t('1336') :this.$t('1314')}}
				</div>
			</div>
			<div class="divider"></div>
			<!-- subtabs -->
			<div class="container container--narrow mgt-50 pdb-50" :style="crop? 'display:none;' : 'display:block;'">
				<div class="t-headline10 l-spacing72 font-b">{{$t('1315')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r l-spacing48 mgt-8">{{$t('1316')}}<br/>{{ $t('1317') }}</div>
				<div class="mgt-50 t-body1 t-color-bodyGrayA font-r l-spacing48">{{ $t('1318') }}</div>
				<div class="mgt-4 t-body1 font-m l-spacing48">{{licenseName}}</div>
				<div class="divider mgt-24"></div>
					<form @submit.prevent="validateForm()" novalidate>
					<div class="mgt-24">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField"
							:class="submitState && validateIssueDate ? 'mdc-text-field--invalid invalid-icon-data' : 'valid-icon-data textFieldVal'"
							id="issueFieldEl"
							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading" :style="submitState && validateIssueDate ? 'border-color: var(--Textfeilderror)!important;':'border-color:var(--Textfeildactive)!important;'"></span>
								<span class="mdc-notched-outline__notch" :style="submitState && validateIssueDate ? 'border-color: var(--Textfeilderror)!important;':'border-color:var(--Textfeildactive)!important;'">
									<span class="mdc-floating-label" id="password-message" :style="submitState && validateIssueDate ? '':'color: rgba(0, 0, 0, 0.6)!important;'">{{$t('1319')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing" :style="submitState && validateIssueDate ? 'border-color: var(--Textfeilderror)!important;':'border-color:var(--Textfeildactive)!important;'"></span>
							</span>
							<input class="mdc-text-field__input" type="text"
								v-model="issueValue"
								v-validate="'required|min:8|max:8'"
								ref="issueDate"
								id="issueDate"
								name="issueDate"
								pattern="[0-9]"
								@keyup="checkNumber"
								maxlength="8"
							>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing"
								tabindex="0"
								role="button"
								:class="issueIcon === 'check' ? 'check_show' : ''"
							>{{issueIcon}}</i>
						</label>
						<div class="mdc-text-field-helper-line d-block">
							<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
								{{$t('1329')}}
							</div>
						</div>
					</div>
					<div class="mgt-17" :style="useValidity? 'display:block;' : 'display:none;'">
						<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
							data-mdc-auto-init="MDCTextField"
							:class="submitState && validateExpiryDate ? 'mdc-text-field--invalid invalid-icon-data' : 'valid-icon-data textFieldVal'"
							id="expiryFieldEl"
							>
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading" :style="submitState && validateExpiryDate ? 'border-color: var(--Textfeilderror)!important;':'border-color:var(--Textfeildactive)!important;'"></span>
								<span class="mdc-notched-outline__notch" :style="submitState && validateExpiryDate ? 'border-color: var(--Textfeilderror)!important;':'border-color:var(--Textfeildactive)!important;'">
									<span class="mdc-floating-label" id="password-message"  :style="submitState && validateExpiryDate ? '':'color: rgba(0, 0, 0, 0.6)!important;'">{{$t('1345')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing" :style="submitState && validateExpiryDate ? 'border-color: var(--Textfeilderror)!important;':'border-color:var(--Textfeildactive)!important;'"></span>
							</span>
							<input class="mdc-text-field__input" type="text"
								v-model="expiryValue"
								v-validate="'required|min:8|max:8'"
								ref="expiryDate"
								id="expiryDate"
								name="expiryDate"
								pattern="[0-9]"
								@keyup="checkNumber"
								maxlength="8"
							>
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button"
								:class="expiryIcon === 'check' ? 'check_show' : ''"
								>{{expiryIcon}}</i>
						</label>
						<div class="mdc-text-field-helper-line d-block">
							<div class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
								{{$t('1330')}}
							</div>
						</div>
					</div>
				<div class="divider mgt-16 mgb-24"></div>
				<div class="t-body3 t-color-bodyGrayA font-r l-spacing48">
					{{ $t('1321') }}{{ $t('1322') }}
				</div>
				<!-- <div v-if="image == null" @click="selectImage" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column">
					<div><i class="material-icons w-28 h-28 font-28 t-color-contentBlueMedium">add</i> </div>
					<div class="t-helper t-color-contentBlueMedium">{{ $t('1323') }}</div>
				</div> -->
				 <input
					ref="cropper"
					type="file"
					id="commentFileUpload"
					:accept="allowExt()"
					@change="uploadFile"
					class="d-none"
            	/>
				<div v-if="image == null" tabindex="0" @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column">
					<div><i class="material-icons w-28 h-28 font-28 t-color-contentBlueMedium">add</i> </div>
					<div class="t-helper t-color-contentBlueMedium">{{ $t('1323') }}</div>
				</div>
				<!-- <div v-if="image != null" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column square-image">
					<img :src="image.resourceUri" @click="selectImage" alt="">
				</div> -->
				<div v-if="image != null" class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column square-image">
					<img  :src="image.resourceUri" @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" style="border: 1px solid var(--Divider);">
					<span tabindex="0" @click.prevent="removeLiencesImage" @keypress.prevent="removeLiencesImage" class="remove-img remove-image-new position-absolute t-color-white"><img src="/images/close.svg" style="width: 20px;height: 20px" /></span>
				</div>
				<div class="mgt-50">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1324')}}</span>
					</button>
					<button class="mdc-button bg-white t-color-secondaryBtnText" tabindex="0" @click="confirmOnCancel()" @keypress="confirmOnCancel()">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1325')}}</span>
					</button>
				</div>
			</form>
			</div>
		<div :style="crop? 'display:block;' : 'display:none;'" class="container container--narrow mgt-50">
			<img :src="imagePreview ? imagePreview : '/images/license-crop-image.png'" alt=""
				v-if="!cropperVisible"
				@click="showFileChooser()" @keypress="showFileChooser()" tabindex="0"
			>
			<vue-cropper
				ref="cropper"
				:src="cropImg"
				alt="Source Image"
				:cropmove="cropImage"
				:autoCropArea="1"
				v-if="cropperVisible"
				class="cropper"
			>
			</vue-cropper>
			<div class="bottom-left position-absolute"></div>
			<div class="bottom-right position-absolute"></div>
			<input
				ref="input"
				type="file"
				name="image"
				accept="image/*"
				@change="setImage"
				class="d-none"
			/>
			<div class="mgt-50 pdb-50">
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8" @click="saveImage()" @keypress="saveImage()" tabindex="0">
					<div class="mdc-button__ripple"></div>
					<span class="mdc-button__label t-body2 font-r">{{ $t('1337') }}</span>
				</button>
				<button class="mdc-button bg-white t-color-secondaryBtnText  b-radius4" @click="openForm"  @keypress="openForm" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1613')}}</span>
				</button>
			</div>
	</div>
</main>
<!--add form ends-->
</div>
<!--add screen ends-->
</div>
</template>

<script>

// importing dependencies
import TopAppBar from '@/components/TopAppBar.vue';
import {topAppBarMixin} from '@/mixins/topAppBar.js';
import {MDCTextField} from '@material/textfield';
import {MDCRipple} from '@material/ripple';
import {joinMixin} from '@/mixins/join.js';
import VueCropper from 'vue-cropperjs';
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import httpService from "@/api/httpService.js";
import licenseApi from "@/api/licenseApi.js";
import memberApi from "@/api/memberApi.js";

export default {
	components: {
		VueCropper,
		TopAppBar,
		TopAppBarDrawer,
	},
	mixins: [topAppBarMixin, joinMixin],
	data() {
		return{
			issueIcon: '',
			expiryIcon: '',
			issueField: null,
			submitState: null,
			crop: false,
			imagePreview: null,
			cropperVisible: false,
			cropImg: '',
			memberId: null,
			memberName: null,
			licenseId: null,
			licenseName: null,
			issueValue: null,
			expiryValue: null,
			image: null,
			useValidity: null,
			brandName: localStorage.getItem('brandName'),
			uploadTypeImg: true,
			type: true
		}
	},
	mounted() {
		// setting topbar
		this.setTopAppBarCloseOnly();

		// setting for material UI
		this.setMaterialUi();

		// get memberId
		this.getMemberId();
	},
	methods: {
		confirmOnCancel(){
			this.$confirm({
				title: this.$t("1339"),
				content:this.$t("1340"),
				accept: this.$t("1342"),
				cancel: this.$t("1341"),
			})
			.then(() => {
				this.$router.go(-1);
			})
			.catch(() => {});
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
					let button = new MDCRipple.attachTo(el);
					return button;
			});
			this.issueField = new MDCTextField(document.querySelector('#issueFieldEl'));
			this.issueField.useNativeValidation = false;
			this.issueDate = '';
			this.issueField.value = this.issueDate;
			this.expiryField = new MDCTextField(document.querySelector('#expiryFieldEl'));
			this.expiryField.useNativeValidation = false;
			this.expiryDate = '';
			this.expiryField.value = this.expiryDate;
		},
		checkNumber(){
			this.issueValue = this.issueValue.replace(/[^0-9]/g,'')
			this.expiryValue = this.expiryValue.replace(/[^0-9]/g,'')
		},
		// isNumber: function(evt) {
				//     evt = (evt) ? evt : window.event;
				//     var charCode = (evt.which) ? evt.which : evt.keyCode;
				//     if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode === 46) {
				//         evt.preventDefault();
				//     } else {
				//         return true;
				//     }
		// },
		openForm() {
			this.crop = false;
		},
		uploadFile(evt) {
			if (!evt.target.files[0]) return;
			this.$showLoading();
				const file = evt.target.files[0];
				const reader = new FileReader();
				reader.onload = (event) => {
				this.imgSrc = event.target.result;
				this.uploadImage(this.imgSrc)
				};
				reader.readAsDataURL(file);

			// 	let blob = this.dataURItoBlob(this.imgSrc);
			// 	console.log('blob',blob)
			// 	let formData = new FormData();
			// 	formData.append('file', blob, 'license.png');

			// httpService.upload(formData).then((response) => {
			// 	this.image = response.data.data[0];
			// 	this.$hideLoading();

			// })
			// .catch((err) => {
			// 	console.log(err);
			// });

		},

		uploadImage(img){
				let blob = this.dataURItoBlob(img);
				let formData = new FormData();
				formData.append('file', blob, 'license.png');

			httpService.upload(formData).then((response) => {
				this.image = response.data.data[0];
				this.$hideLoading();

			})
			.catch((err) => {
				console.log(err);
			});
		},

		openFileUpload(allowImg,type) {
			this.uploadTypeImg = allowImg;
			this.type = type
			setTimeout(() => {
				document.getElementById("commentFileUpload").click();
			}, 0);
		},

		allowExt() {
			return this.type ? "image/jpeg,image/png" : "image/jpeg,image/png";
		},

		removeLiencesImage() {
			this.image=null
		},

		selectImage() {
			this.crop = true;
			this.cropperVisible = false;
		},
		showFileChooser() {
			this.$refs.input.click();
		},
		setImage(e) {
			this.cropperVisible = true
			const file = e.target.files[0];
			if (file.type.indexOf('image/') === -1) {
				return;
			}
			if (typeof FileReader === 'function') {
				const reader = new FileReader();
				reader.onload = (event) => {
				this.imgSrc = event.target.result;
				// rebuild cropperjs with the updated source
				this.$refs.cropper.replace(event.target.result);
				};
				reader.readAsDataURL(file);
			} else {
				console.log('Sorry, FileReader API not supported');
			}
		},
		cropImage() {
			this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
		},
		dataURItoBlob(dataURI) {
			// convert base64/URLEncoded data component to raw binary data held in a string
			let byteString
			if (dataURI.split(',')[0].indexOf('base64') >= 0){
				byteString = atob(dataURI.split(',')[1])
			}else {
				byteString = unescape(dataURI.split(',')[1])
			}

			// separate out the mime component
			let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to a typed array
			let ia = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			return new Blob([ia], {type:mimeString});
		},
		getMemberId(){
			memberApi.getMemberInfo().then((response) => {
				this.memberId = response.data.data.id;
				this.memberName = response.data.data.name.fullName;
				let params = {
					"memberId":this.memberId
				};
				this.getLicenseResponsibility(params);
			}).catch((err) => {
				console.log(err);
			});
		},
		getLicenseResponsibility(params) {
			licenseApi.getLicenseResponsibility(params).then((response)=>{
				this.useValidity = response.data.data.useValidPeriod;
				this.licenseName = response.data.data.name;
				this.licenseId = response.data.data.id;
			//	console.log(response.data.data);
			}).catch((err)=>{
				console.log(err);
			});
		},
		saveImage() {
			this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
			let blob = this.dataURItoBlob(this.cropImg);
			let formData = new FormData();
			formData.append('file', blob, 'license.png');
			httpService.upload(formData).then((response) => {
				this.image = response.data.data[0];
				console.log(response);
				this.openForm();
			})
			.catch((err) => {
				console.log(err);
			});
		},
		getTimeStamp(date) {
			if(date){
				let year = date.substring(0,4);
				let month = date.substring(4,6);
				let day = date.substring(6,8);
				let timeStamp = new Date(year, month - 1, day).getTime();
				return timeStamp;
			} else {
				return null;
			}
		},
		validateForm() {
			// check if image is available
			if(this.image == null){
				this.$snackOpen({
					contents: this.$t('1338'),
					btnDisplayYN: false,
					btnDisplay: '',
					timeoutMs: 4000
				}).then(() => { });
				return false;
			}
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					// add license
					this.addLicense();
				} else {
					this.focusFirstInvalidElement()
				}
			});
		},
		addLicense() {
			let params = {
				id:null,
				licenseResponsibility: {
					id: this.licenseId,
					name: this.licenseName
				},
				member: {
					id: this.memberId,
					name: this.memberName
				},
				issueDate: this.getTimeStamp(this.issueValue),
				expiryDate: this.getTimeStamp(this.expiryValue),
				file: this.image
			}

			licenseApi.addLicense(params).then((response)=>{
				this.$router.push("/viewLicense");
			}).catch((err) => {
				console.log(err);
			});
		}
	},
	computed: {
		validateIssueDate() {
		let returnValue = false;
		if (this.submitState) {
				if (this.errors.has('issueDate')) {
					returnValue = true;
					this.issueIcon = 'report_problem';
				} else {
					returnValue = false;
					this.issueIcon = 'check';
				}
		}
			this.issueField.valid === !returnValue ? '' : this.issueField.valid = !returnValue;
			return returnValue;
		},
		validateExpiryDate() {
			if(this.useValidity){
				let returnValue = false;
				if (this.submitState) {
					if (this.errors.has('expiryDate')) {
						returnValue = true;
						this.expiryIcon = 'report_problem';
					} else {
						returnValue = false;
						this.expiryIcon = 'check';
					}
				}
				this.expiryField.valid === !returnValue ? '' : this.expiryField.valid = !returnValue;
				return returnValue;
			} else {
				this.addLicense();
			}
		}
	},
}
</script>

<style scoped>
	/* specific for this screen only */
.bg-red {
	background-color: var(--secondaryBtnText)  !important;
}
.check_show{
	display: block !important;
}
.t-color-red1{
	color: var(--Textfeilderror) !important;
}
.cropper-view-box {
	outline: 1px solid var(--Secondarybtntext)!important;
	outline-color: var(--Secondarybtntext)!important;
}
.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
	border-color: var(--Textfeildactive) !important;
}
</style>
